
import { normalize } from "react-phone-input-auto-format";

export const isNotBlankString = (values, value) => {
    return value && value.trim().length > 0;
}

export const isValidEmail = (values, value) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(value).trim().toLowerCase());
}

export const isValidCellNumber = (values, value) => {
    const phNumber = normalize(value);
    if (phNumber && phNumber.trim().length > 0) {
        const a = Number(phNumber);
        return phNumber && phNumber.trim().length === 10 && !isNaN(a) && a > 0;
    }
    else if (value && value.length > 0 /*&& isNaN(Number(value))*/) {
        return false;
    }
    return true;
}